
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/manual/[slug]",
      function () {
        return require("private-next-pages/manual/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/manual/[slug]"])
      });
    }
  